module.exports = __webpack_public_path__ + "static/media/timer.4b159228.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/timer.svg
// module id = 150
// module chunks = 0